export const environment = {
  UserGuideUrl:
    'https://elearning.easygenerator.com/bcd568f0-29e3-43fb-a042-238bfbb04e6e/',
  UserGuideSnapshotUrl:
    'https://elearning.easygenerator.com/4168a9e6-5f42-4a18-80cd-5aeab0add565/',
  baseApiUrl: 'https://de-kraftheinz-uat.azurewebsites.net/',
  kantarClientID: 'bdc2d0be-fb97-4f9e-9291-20f6436b61bd',
  kantarApiClientID: 'c27d11de-457f-4903-8f02-2b56b9c6d349',
  kantarAuthorityID:
    'https://login.microsoftonline.com/1e355c04-e0a4-42ed-8e2d-7351591f0ef1',
  redirectUrl: 'https://kraft-uat-brandhealthdashboard.kantar.com/landing',
  // redirectUrl: 'https://dev-dataexplorer.kantar.com/landing',  // baseApiUrl: 'https://kapdashboardapidev.azurewebsites.net/',
  logoutURL: 'https://kraft-uat-brandhealthdashboard.kantar.com/signout-oidc',
  baseUrl: '/',
  sessionTimeOut: 60,
  env: 'dev',
  showUploadModule: true,
};
